import apiGroupsTrainers from '@/api/groups-trainers'

const state = {
  error: null,
  isSubmitting: false
}

export const mutationTypes = {
  deleteGroupsTrainersStart:
    '[delete groups trainers] Delete groups trainers start',
  deleteGroupsTrainersSuccess:
    '[delete groups trainers] Delete groups trainers success',
  deleteGroupsTrainersFailure:
    '[delete groups trainers] Delete groups trainers failure'
}

export const actionTypes = {
  deleteGroupsTrainers: '[delete groups trainers] Delete groups trainers'
}

const mutations = {
  [mutationTypes.deleteGroupsTrainersStart](state) {
    state.isSubmitting = true
  },

  [mutationTypes.deleteGroupsTrainersSuccess](state) {
    state.isSubmitting = false
  },

  [mutationTypes.deleteGroupsTrainersFailure](state, payload) {
    state.error = payload
    state.isSubmitting = false
  }
}

const actions = {
  [actionTypes.deleteGroupsTrainers](context, {id}) {
    context.commit(mutationTypes.deleteGroupsTrainersStart)
    return new Promise(resolve => {
      apiGroupsTrainers
        .deleteGroupsTrainers(id)
        .then(response => {
          context.commit(mutationTypes.deleteGroupsTrainersSuccess)
          resolve(response.data)
        })
        .catch(resolve => {
          context.commit(
            mutationTypes.deleteGroupsTrainersFailure,
            resolve.response.data.errors
          )
        })
    })
  }
}

export default {
  state,
  mutations,
  actions
}
